<main class="esf-main-content esf-main-content--has-sidebar -has-transition" [class.-is-open]="sidebarService.isOpened">
  <div class="esf-container main-content">

    <h1 class="esf-heading esf-heading--page esf-action-heading">
      <span i18n='Main heading for the customer profile component@@customerOverviewComponent.heading.merchandising' class="esf-action-heading__text">Merchandising</span>
    </h1>

    <div class="esf-form-item"
         app-form-field-search
         [placeholder]="flTranslations.i18nSearchMerch"
         [id]="'search'"
         [control]="options.get('searchBy')"
         (inputChanged)="triggerSearch()">
    </div>

    <app-paginated-table [columns]="columns"
                         [keys]="keys"
                         [data]="orders"

                         [baseApi]="baseApi"
                         [customQueries]="customQueries"
                         (dataFetchedEmitter)="setNewOrdersList($event)"

                         [emptyStateText]="tablesTranslations.i18nNoMerchandising"
                         [emptyStateIcon]="'#esf-icon-merch'">

    </app-paginated-table>

  </div>
</main>
